// extracted by mini-css-extract-plugin
export default {"layout":"Home_layout__LaJBm","layoutTitle":"Home_layoutTitle__-258M"};